<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-75"
    menu-class="dropdown-menu-media dropdown-menu-right"
    left
  >
    <template #button-content>
      <feather-icon
        :badge="chats.length"
        badge-classes="bg-danger"
        class="text-body"
        icon="MessageCircleIcon"
        size="21"
      />
    </template>
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $tc("chat.chats") }}
        </h4>
      </div>
    </li>

    <!-- Chats -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-link v-for="chat in chats" :key="chat.id">
        <b-media
          @click="openChat(chat)"
          draggable
          @dragstart="onDragStart(chat)"
          @dragend="onDragEnd"
        >
          <template #aside>
            <b-avatar size="32">
              <span class="d-flex align-items-center">
                <feather-icon
                  :icon="chat.error ? 'CollectionIcon' : 'MessageSquareIcon'"
                  size="16"
                />
              </span>
            </b-avatar>
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ chat.name }}
              <small class="notification-text float-right">{{
                parseDate(chat.created_at)
              }}</small>
            </span>
          </p>
          <small class="notification-text">{{ chat.user_email }}</small>
        </b-media>
      </b-link>
    </vue-perfect-scrollbar>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ref, onMounted } from "@vue/composition-api";
import axios from "@axios";
import LayoutApi from "@/libs/LayoutApi.js";
import { SLOT_TYPES } from "@/config/layoutConfig";
import dateParser from "@/libs/date-parser";
import store from "@/store";
import chat from "@/libs/i18n/sections/en/chat";
import { useToast } from "vue-toastification/composition";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { getUserData } from "@/auth/utils";

const layoutApi = new LayoutApi(store);


export default {
  components: {
    BNavItemDropdown,
    VuePerfectScrollbar,
  },
  setup() {
    const chats = ref([]);
    const { t } = useI18nUtils();
    const toast = useToast();
    const userData = ref(getUserData());

    const trans = {
      "chat.new_emergency_chat": t("chat.new_emergency_chat"),
    };

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const fetchChats = async () => {
      if (userData.value.enabled_chat && Number(window.__env.VUE_APP_ENABLED_CHAT)) {
        try {
          const response = await axios.get(
            "/v1/user_app_group_chat_get_waiting_chats"
          );
          chats.value = response.data.data;
          console.log(chats.value);
        } catch (error) {
          console.error("Error fetching chats:", error);
        }
      }
    };

    const openChat = (chat) => {
      layoutApi.setSlotData(SLOT_TYPES.CHAT, `CHAT_${chat.roomId}`, {
        chat,
      });
    };

    const onDragStart = (chat) => {
      openChat(chat);
    };

    const onDragEnd = () => {};

    onMounted(() => {
      fetchChats();
      setTimeout(() => {
        window.Echo.private(`chat-status-${user.id}`).listen(
          "UserAppGroupChatStatusChangedEvent",
          (data) => {
            console.log('New Event Chat', {data})
            if (!data.id) {
              return;
            }

            if (data.status === "waiting") {
              const idx = chats.value.findIndex((c) => c.id === data.id); //add if its not in
              if (idx === -1) {
                console.log('newChatData', data)
                toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: trans["chat.new_emergency_chat"],
                        variant: "infor",
                        icon: "MessageSquareIcon",
                        text: data.user_email,
                        timeout: 5000,
                      },
                    });
                chats.value.push(data);
              } else {
                chats.value.splice(idx, 1, data); //if its in and waiting update
              }
            } else {
              //if its not waiting remove
              const idx = chats.value.findIndex((c) => c.id === data.id);
              if (idx !== -1) {
                chats.value.splice(idx, 1);
              }
            }
          }
        );
      }, 3000);
    });

    const parseDate = (date) => {
      return dateParser.parseDate(date);
    };

    const user = store.getters["user/getUser"];

    return {
      chats,
      perfectScrollbarSettings,
      openChat,
      onDragStart,
      onDragEnd,
      parseDate,
    };
  },
};
</script>

<style></style>
